module.exports = __webpack_public_path__ + "9a54a1cc5c6bbdca7966d781edbaf238.jpg";